import { inject, Injectable, Injector } from '@angular/core'
import { Translation, TranslocoLoader } from '@jsverse/transloco'
import { HttpClient } from '@angular/common/http'
import { ConfigService } from '../../../../src/app/services/config.service'
import { catchError, of, take, map, mergeMap, forkJoin } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
   private http = inject(HttpClient)

   constructor(private readonly injector: Injector) {}

   getTranslation(lang: string) {
      // using the injector to get the ConfigService to avoid a circular dependency
      const config = this.injector.get(ConfigService)

      // we're doing the on config change here to make sure we get the latest apiUrl and apiParams
      return config.onConfigChange$.pipe(
         take(1),
         mergeMap((config) => {
            const params = new URLSearchParams()
            const apiParams = config.apiParams
            // serialize apiParams to a query string
            for (const key in apiParams) {
               params.set(key, apiParams[key])
            }
            params.set('lang', lang)
            const assetsUrl = new URL(`assets/i18n/${lang}.json`, config.sourceUrl)

            const apiI18nCall = this.http.get<Translation>(`${config.apiUrl}/translations?${params.toString()}`)
               .pipe(catchError(() => {
                  // we got an error downloading from the api, just return an empty response, it will merge with the local i18n
                  return of({})
               }))
            const localI18nCall = this.http.get<Translation>(assetsUrl.toString())

            return forkJoin([apiI18nCall, localI18nCall])

         }),
         map((data) => {
            // now we merge the api and local i18n, the API should override the local
            const mergedI18n ={ ...data[1], ...data[0] }
            return mergedI18n
         })
      )
   }
}
